import {memo} from 'react';
import {FilterBy} from '~/ViewInvitation/components/Guestlist/FilterBy';
import {GuestlistOverlayHeader} from '~/ViewInvitation/components/Guestlist/GuestlistOverlayHeader';
import {GuestsCount} from '~/ViewInvitation/components/Guestlist/GuestsCount';
import {List} from '~/ViewInvitation/components/Guestlist/List/List';
import {SearchInput} from '~/ViewInvitation/components/Guestlist/SearchInput';
import {SortBy} from '~/ViewInvitation/components/Guestlist/SortBy';

import * as styles from './Guests.module.scss';

interface GuestsProps {
  onClose: () => void;
}

export const Guests = memo(({onClose}: GuestsProps) => (
  <>
    <div className={styles.guestsHeader}>
      <GuestlistOverlayHeader onClose={onClose} goBack={onClose} />
      <SearchInput />
      <FilterBy />
      <SortBy />
      <GuestsCount />
    </div>
    <div className={styles.guestsContainer}>
      <List />
    </div>
  </>
));

Guests.displayName = 'Guests';
